var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.48559 0.00556933C9.37969 0.0207867 9.28892 0.0664333 9.21328 0.14252C9.03173 0.325129 7.65503 1.74035 6.2632 3.186C4.9924 4.49469 3.91827 5.60557 3.60057 5.94035L0.726135 3.74904C0.529463 3.59687 0.24202 3.62731 0.0907338 3.82513C-0.0605522 4.02296 -0.030295 4.31209 0.166377 4.46426C0.166377 4.46426 0.166377 4.46426 0.181505 4.46426L3.35851 6.89905C3.54005 7.036 3.79724 7.02079 3.94852 6.8534C4.13007 6.67079 5.50677 5.25557 6.8986 3.80992C8.29043 2.36427 9.71252 0.888178 9.84868 0.766439C10.0302 0.58383 10.0302 0.294698 9.8638 0.127307C9.77303 0.0360023 9.62175 -0.00964806 9.48559 0.00556933Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.f2b8f2f17cb85765e919b60fed102a02.svg";
export { ForwardRef as ReactComponent };